module.exports = __webpack_public_path__ + "img/delayed-dosing.5562024a.png";